type Props =  {
  width?: number;
  height?: number;
}

export default function StarIcon({ width = 20, height = 21 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 21"
      aria-hidden="true"
      focusable="false"
    >
      <path fill="currentColor" d="M10 14.1356L5.67377 16.5L6.64001 11.7521L3 8.46556L7.92342 7.89561L10 3.5L12.0766 7.89561L17 8.46556L13.36 11.7521L14.3263 16.5L10 14.1356Z" />
    </svg>
  )
}
